/**
 * The `redact-tdo-status-history` data-registry id (VE-26730), and its
 * config override.
 *
 * The id is identical in every environment the app ships to, so it is baked in
 * here rather than required in `config*.js`: a deployment whose config predates
 * this feature (or a local `static/config.js` copied from an older template)
 * still gets the feature instead of silently self-disabling.
 *
 * The config key remains the rollback lever, with the two cases distinguished
 * deliberately:
 *
 * - key absent (`undefined`) — "no opinion", use the built-in default.
 * - key present but empty (`tdoStatusHistoryRegistryId: ''`) — an explicit
 *   opt-out for an environment where the schema is not provisioned; the module
 *   self-disables exactly as it did when the key was mandatory.
 *
 * A non-empty value still overrides the default outright, so a one-off
 * environment can point at a different registry.
 */
export const DEFAULT_TDO_STATUS_UPDATES_REGISTRY_ID =
  '1b5c8d1e-7a6f-43d5-baf0-a5ab5788364c';

export const resolveTdoStatusUpdatesRegistryId = (
  configuredId: string | null | undefined
): string | undefined =>
  (configuredId ?? DEFAULT_TDO_STATUS_UPDATES_REGISTRY_ID) || undefined;
